import { render, staticRenderFns } from "./IconExclamationCircleSolid.vue?vue&type=template&id=097becbc"
import script from "./IconExclamationCircleSolid.vue?vue&type=script&lang=js"
export * from "./IconExclamationCircleSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports